import { render, staticRenderFns } from "./TabSetting.vue?vue&type=template&id=8fc027a2&"
import script from "./TabSetting.vue?vue&type=script&lang=js&"
export * from "./TabSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports